<template>
  <div class="form-wrapper">
    <div class="container">
      <div class="form">
        <form ref="formElem" class="form-inner">
          <slot name="title">
            <div class="form-title">
              <img src="img/form/papers.svg" alt="">
              <div>{{ title }}</div>
            </div>
          </slot>
          <slot name="form">
            <div class="form-inputs">
              <div class="form-inputs-left">
                <div class="input-wrapper">
                  <label for="name">{{ getLocalization('Your Name') }}</label>
                  <input class="input" id="name" type="text" :placeholder="getLocalization('Your Name')">
                </div>
                <div class="input-wrapper">
                  <label for="email">{{getLocalization('Your Email or Telegram')}}</label>
                  <input class="input" id="email" type="text" placeholder="Ваше имя">
                </div>
              </div>
              <div class="form-inputs-right">
                <div class="input-wrapper">
                  <label for="message">{{ getLocalization('Message') }}</label>
                  <textarea class="textarea" id="message" type="text" :placeholder="getLocalization('Text of your message')"></textarea>
                </div>
              </div>
            </div>
          </slot>
          <slot name="submit">
            <div class="cf-turnstile" :data-sitekey="captchaKey"></div>
            <div class="form-submit">
              <button class="button orange form-btn" @click="sendForm">
                <img src="img/form/send.svg" alt="">
                Отправить
              </button>
              <div class="form-privacy">
                {{getLocalization('I agree')}} <a href="#">{{getLocalization('with the privacy policy and use of the requested data')}}</a>
              </div>
            </div>
          </slot>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import BaseAdminMixin from "../../admin/components/mixins/BaseAdminMixin.vue";

export default {
  name: "formWriteUs",
  mixins: [
    BaseAdminMixin
  ],
  props: {
    title: {
      type: String,
      default: 'Write to us'
    },
    csrf: {
      type: String,
      required: true
    },
    captchaKey: {
      type: String,
      required: true,
    },
    page: {
      type: String,
      default: null,
    }
  },
  mounted() {
    // const script = document.createElement('script');
    // script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
    // script.async = true;
    // script.defer = true;
    // document.head.appendChild(script);
  },
  data() {
    return {}
  },
  methods: {
    async sendForm() {
      let form = new FormData(this.$refs.formElem);
      if (this.page) {
        form.append('page', this.page);
      }
      await this.doWithStopRequest(() => this.doWithLoader(async () => {
        let response = await this.sendRequest(
            '/sendFeedback',
            'post',
            form);
        if (response) {
          this.$refs.formElem.reset();
          await this.alertMessage(
              this.getLocalization('You question has been sent'),
              'good'
          );
        }
      }));
    },
  }
}
</script>
